var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10472_219176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5448 11.8609C17.5814 11.5859 17.5998 11.3017 17.5998 10.9992C17.5998 10.7059 17.5814 10.4126 17.5356 10.1376L19.3964 8.68922C19.5614 8.56088 19.6073 8.31339 19.5064 8.13005L17.7464 5.08672C17.6364 4.88505 17.4073 4.82089 17.2056 4.88505L15.0148 5.76505C14.5564 5.41672 14.0706 5.12339 13.5298 4.90339L13.1998 2.57505C13.1631 2.35505 12.9798 2.19922 12.7598 2.19922H9.23978C9.01977 2.19922 8.84561 2.35505 8.80894 2.57505L8.47894 4.90339C7.93811 5.12339 7.44311 5.42589 6.99394 5.76505L4.80311 4.88505C4.60144 4.81172 4.37228 4.88505 4.26228 5.08672L2.51144 8.13005C2.40144 8.32255 2.43811 8.56088 2.62144 8.68922L4.48228 10.1376C4.43644 10.4126 4.39978 10.7151 4.39978 10.9992C4.39978 11.2834 4.41811 11.5859 4.46394 11.8609L2.60311 13.3092C2.43811 13.4376 2.39228 13.6851 2.49311 13.8684L4.25311 16.9117C4.36311 17.1134 4.59228 17.1776 4.79394 17.1134L6.98478 16.2334C7.44311 16.5817 7.92894 16.8751 8.46977 17.0951L8.79978 19.4234C8.84561 19.6434 9.01977 19.7992 9.23978 19.7992H12.7598C12.9798 19.7992 13.1631 19.6434 13.1906 19.4234L13.5206 17.0951C14.0614 16.8751 14.5564 16.5817 15.0056 16.2334L17.1964 17.1134C17.3981 17.1867 17.6273 17.1134 17.7373 16.9117L19.4973 13.8684C19.6073 13.6667 19.5614 13.4376 19.3873 13.3092L17.5448 11.8609ZM10.9998 14.2992C9.18478 14.2992 7.69977 12.8142 7.69977 10.9992C7.69977 9.18422 9.18478 7.69922 10.9998 7.69922C12.8148 7.69922 14.2998 9.18422 14.2998 10.9992C14.2998 12.8142 12.8148 14.2992 10.9998 14.2992Z",
    fill: "#FDFDFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10472_219176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.b84b46801037a204defc18e95a0d7a33.svg";
export { ForwardRef as ReactComponent };